import { Component, ReactElement } from 'react';
import { HelmetWithTitleAndDescription } from '../../../../../../shared/frontend/components/helmetHelper';
import { DisableAdsOnPage } from '../../../../../../shared/frontend/components/ads/disableAdsOnPage';
import { ModerationPolicyContent } from '../../../../../../shared/frontend/components/presentational/moderationPolicyContent';
import styles from './policyPageStyles';

export default class ModerationPolicyPage extends Component<any, {}> {
  public render(): ReactElement<any> {
    return (
      <div>
        <HelmetWithTitleAndDescription title="User-Generated Content Moderation Policy" />
        <DisableAdsOnPage />
        <div>
          <div className="slds-p-around--large text-white" style={{ backgroundColor: '#4f4b49' }}>
            <ModerationPolicyContent styles={styles} />
          </div>
        </div>
      </div>
    );
  }
}
